export type FrontendType = 'frontendType';

export type BackendType = 'backendType';

export type ObjectType = BackendType | FrontendType;

export type StarjackDate<T extends ObjectType = FrontendType> =
    T extends FrontendType ? Date : number[];

export type StarjackDateISO<T extends ObjectType = FrontendType> =
    T extends FrontendType ? Date : string;

export const convertIsoDateStringToDate = (isoDate: string): Date | null => {
    if (!isoDate) return null;

    return new Date(isoDate);
};

export const multiLangStringOptions = ['de', 'en'] as const;

export type MultiLangStringOption = (typeof multiLangStringOptions)[number];

export type MultiLangString = Record<MultiLangStringOption, string>;

export enum Language {
    DE = 'DE',
    EN = 'EN',
}

export type DateRange = [Date?, Date?];

export type StarjackDateRange<T extends ObjectType = FrontendType> = {
    from: StarjackDate<T>;
    to: StarjackDate<T>;
};

export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}
